module.exports = __webpack_public_path__ + "img/oredoo.c8fecc28.svg";